import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const OptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const SelectionCount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const SectionError = styled.div``;

export const NoticeSlot = styled.div`
  & > * {
    margin-block: 0;
  }
`;
